import React from 'react';

/**
 * Moderne Ordner-Karte fuer die Wissen-Uebersicht (Portal-Designsprache).
 * Klick oeffnet den Ordner; Umbenennen/Loeschen erscheinen beim Hover.
 */
export default function OrdnerKachel({ ordner, zaehler, onOeffnen, onBearbeiten, onLoeschen }) {
  const farbe = ordner.farbe || '#64748b';

  return (
    <div className="group relative animate-fade-in-up">
      <button
        type="button"
        onClick={() => onOeffnen(ordner)}
        className="flex w-full flex-col rounded-2xl border border-line bg-paper-soft p-5 text-left shadow-sm ring-1 ring-transparent transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
        style={{ borderTopColor: farbe, borderTopWidth: '3px' }}
      >
        <span
          className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl text-xl shadow-sm"
          style={{ backgroundColor: `${farbe}22`, color: farbe }}
          aria-hidden="true"
        >
          📁
        </span>
        <h3 className="line-clamp-1 font-serif text-lg font-semibold text-ink">{ordner.name}</h3>
        <p className="mt-1 font-mono text-xs text-ink-muted">
          {zaehler.notizen} {zaehler.notizen === 1 ? 'Notiz' : 'Notizen'} · {zaehler.unterordner} Unterordner
        </p>
      </button>

      <div className="absolute right-2.5 top-2.5 flex gap-0.5 opacity-0 transition-opacity group-hover:opacity-100">
        <button
          type="button"
          onClick={() => onBearbeiten(ordner)}
          title="Umbenennen"
          className="rounded-lg bg-paper/80 px-1.5 py-1 text-sm text-ink-muted backdrop-blur hover:text-ink"
        >
          ✎
        </button>
        <button
          type="button"
          onClick={() => onLoeschen(ordner)}
          title="Löschen"
          className="rounded-lg bg-paper/80 px-1.5 py-1 text-sm text-ink-muted backdrop-blur hover:text-red-600"
        >
          🗑
        </button>
      </div>
    </div>
  );
}
